import * as React from "react";
import ContainerBox from "myshubhlife-component/container-box";
import {useEffect, useState} from "react";
import {connect} from "react-redux";
import {IReduxState} from "reducers";
import {ILoanApprovalInfo} from "StateInterface";
import {getLatestLoanOpp} from "consent/actions";
import Loading from "components/loading";
import {MessageType} from "utils/variables";
import {partnerOfferings} from "login/config";
import Flashcard from "myshubhlife-component/Flashcard";

interface IConnectProps {
    dispatch?: (action: any) => void;
    userId: number;
    loanApprovalInfo: ILoanApprovalInfo;
    utm_source?: string;
    lenderOpportunityId: string;
}
const maxReloadCount = 5;
const ConsentError = (props: IConnectProps) => {
    const [isReload, setIsReload] = useState(true);
    const [reloadCount, setReloadCount] = useState(0);
    useEffect(() => {
        let interval;
        if (props.loanApprovalInfo && !props.loanApprovalInfo.subStatuses && isReload) {
            interval = setInterval(() => {
                setReloadCount((prev) => prev + 1);
                props.dispatch(getLatestLoanOpp(props.lenderOpportunityId));
            }, 5000);
        }
        if ((props.loanApprovalInfo &&
            props.loanApprovalInfo.subStatuses &&
            props.loanApprovalInfo.subStatuses.length) || reloadCount === maxReloadCount) {
            setIsReload(false);
        }
        return () => clearInterval(interval);
    }, [props.loanApprovalInfo, isReload]);
    return (
        <ContainerBox>
            {
                isReload ?
                <Loading
                    active={isReload}
                    msg={`Please wait, ${reloadCount > 1 ? "It is taking more than expected" : "We are processing"}`}
                /> :
                <Flashcard
                    description="Looks like something is missing"
                    heading="Something's Wrong"
                    supportEmail={true}
                    supportText="Please contact support"
                    messageType={MessageType.ERROR}
                    supportEmailText={partnerOfferings[props.utm_source]?.supportEmail}
                />
            }
        </ContainerBox>
    );
};

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        userId: state.login.auth.userId,
        lenderOpportunityId: state.consent.lenderOpportunityId,
        loanApprovalInfo: state.consent.loanApprovalInfo,
        utm_source: state.login.authExt && state.login.authExt.utm_source ? state.login.authExt.utm_source : null,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(ConsentError);
